import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// State-management
import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
import store from '@redux-state/index';
import './index.css';
import { AppRoutes } from './routes/routes';

import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter(AppRoutes);

export default () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        {/* <PersistGate persistor={persistor} loading={<div>Loading...</div>}> */}
          <RouterProvider router={router} />
        {/* </PersistGate> */}
      </Provider>
    </React.StrictMode>
  );

  reportWebVitals();
}